var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.dialogVisible
    ? _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.$t("delegatedOperationText"),
            visible: _vm.dialogVisible,
            width: "900px",
            "custom-class": "delegated-operation-dialog",
            "append-to-body": true,
            "close-on-click-modal": false,
            "before-close": _vm.handleClose,
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c("BjPage", {
            ref: "BjPage",
            attrs: {
              height: "420px",
              "query-params": _vm.queryParams,
              "col-span": 6,
              "search-btn-span": 6,
              "get-action": _vm.queryCustomerList,
              serial: true,
              selection: false,
              "right-toolbar-hide": true,
              "before-reset-search": _vm.beforeResetSearch,
            },
            nativeOn: {
              submit: function ($event) {
                $event.preventDefault()
              },
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "baseForm",
                  fn: function () {
                    return [
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t(
                                  "AccountManagement.customer.account"
                                ),
                                prop: "clientCode",
                              },
                            },
                            [
                              _c("BjSelectLov", {
                                attrs: {
                                  "option-list": _vm.newClientCode,
                                  placeholder: _vm.$t(
                                    "AccountManagement.customer.account"
                                  ),
                                },
                                on: {
                                  change: function (value) {
                                    return _vm.handleSelectQuery(
                                      "clientCode",
                                      value
                                    )
                                  },
                                },
                                model: {
                                  value: _vm.queryParams.clientCode,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.queryParams, "clientCode", $$v)
                                  },
                                  expression: "queryParams.clientCode",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t(
                                  "AccountManagement.customer.name"
                                ),
                                prop: "cusId",
                              },
                            },
                            [
                              _c("BjSelectLov", {
                                attrs: {
                                  "option-list": _vm.customerList,
                                  placeholder: _vm.$t("customerNameText"),
                                },
                                on: {
                                  change: function (value) {
                                    return _vm.handleSelectQuery("cusId", value)
                                  },
                                },
                                model: {
                                  value: _vm.queryParams.cusId,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.queryParams, "cusId", $$v)
                                  },
                                  expression: "queryParams.cusId",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("workOrderList.Customer"),
                                prop: "csgCustomer",
                              },
                            },
                            [
                              _c("BjSelectLov", {
                                attrs: {
                                  "option-list": _vm.customerNameList,
                                  placeholder: _vm.$t("workOrderList.Customer"),
                                },
                                on: {
                                  change: function (value) {
                                    return _vm.handleSelectQuery(
                                      "csgCustomer",
                                      value
                                    )
                                  },
                                },
                                model: {
                                  value: _vm.queryParams.csgCustomer,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.queryParams,
                                      "csgCustomer",
                                      $$v
                                    )
                                  },
                                  expression: "queryParams.csgCustomer",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ]
                  },
                  proxy: true,
                },
                {
                  key: "tableColumn",
                  fn: function () {
                    return [
                      _c("el-table-column", {
                        attrs: {
                          label: _vm.$t("customerNameText"),
                          prop: "cusName",
                          align: "center",
                          width: "160",
                        },
                      }),
                      _c("el-table-column", {
                        attrs: {
                          label: _vm.$t("clientCodeText"),
                          prop: "clientCode",
                          align: "center",
                          width: "160",
                        },
                      }),
                      _c("el-table-column", {
                        attrs: {
                          label: _vm.$t("workOrderList.Customer"),
                          prop: "csgCustomer",
                          align: "center",
                          width: "160",
                        },
                      }),
                      _c("el-table-column", {
                        attrs: {
                          label: _vm.$t("table.statusText"),
                          prop: "enabled",
                          align: "center",
                          width: "160",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (ref) {
                                var row = ref.row
                                return [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        row.enabled === false
                                          ? _vm.$t("disableText")
                                          : _vm.$t("enableText")
                                      ) +
                                      " "
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          2946948074
                        ),
                      }),
                      _c("el-table-column", {
                        attrs: {
                          label: _vm.$t("table.operationText"),
                          align: "center",
                          width: "160",
                          fixed: "right",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (ref) {
                                var row = ref.row
                                return [
                                  _c(
                                    "el-button",
                                    {
                                      attrs: {
                                        type: "text",
                                        disabled: row.enabled === false,
                                        loading:
                                          _vm.delegatingId ===
                                          _vm.getRowKey(row),
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.handleDelegate(row)
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(_vm.$t("delegateOnceText")) +
                                          " "
                                      ),
                                    ]
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          1188420674
                        ),
                      }),
                    ]
                  },
                  proxy: true,
                },
              ],
              null,
              false,
              2022404391
            ),
          }),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }